'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FallbackImageLoader = require('@scoir/components-core/dist/components/FallbackImageLoader');

var _FallbackImageLoader2 = _interopRequireDefault(_FallbackImageLoader);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrestLoader = function (_React$Component) {
    _inherits(CrestLoader, _React$Component);

    function CrestLoader() {
        _classCallCheck(this, CrestLoader);

        return _possibleConstructorReturn(this, (CrestLoader.__proto__ || Object.getPrototypeOf(CrestLoader)).apply(this, arguments));
    }

    _createClass(CrestLoader, [{
        key: 'getAltText',
        value: function getAltText() {
            var alt = this.props.alt;

            if (alt === "") {
                return "";
            }
            return alt || 'College Crest';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isFullSize = _props.isFullSize,
                scid = _props.scid,
                className = _props.className,
                imgClassName = _props.imgClassName;

            var sourceUrl = isFullSize ? (0, _.getFullImageUrl)(scid) : (0, _.getThumbImageUrl)(scid);
            var fallbackUrl = isFullSize ? _.DEFAULT_CREST_FULL : _.DEFAULT_CREST_THUMB;
            var altText = this.getAltText();
            return _react2.default.createElement(_FallbackImageLoader2.default, {
                className: className,
                imgClassName: imgClassName,
                alt: altText,
                src: sourceUrl,
                fallback: fallbackUrl
            });
        }
    }]);

    return CrestLoader;
}(_react2.default.Component);

CrestLoader.propTypes = {
    alt: _propTypes2.default.string,
    scid: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string,
    imgClassName: _propTypes2.default.string,
    isFullSize: _propTypes2.default.bool
};
CrestLoader.defaultProps = {
    isFullSize: false
};
exports.default = CrestLoader;
//# sourceMappingURL=index.js.map